import React from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";

const data = [
    { name: "Jan", sales: 400 },
    { name: "Feb", sales: 300 },
    { name: "Mar", sales: 500 },
    { name: "Apr", sales: 200 },
    { name: "May", sales: 350 },
];

const CustomBarChart = () => {
    return (

        <div className="row pb-3">
            <div className="col-12 col-sm-6 col-md-6 col-lg-12 mt-2">
                    <div className="card">
                        <div className="card-body w-100">
                            <div className="d-flex justify-content-center">
                                {/* Add your chart or content here */}
                               
                                <div style={{ width: "100%", height: 300 }}>
                                    <ResponsiveContainer>
                                        <BarChart data={data}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="name" />
                                            <YAxis />
                                            <Tooltip />
                                            <Legend />
                                            <Bar dataKey="sales" fill="#8884d8" />
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </div>





    );
};

export default CustomBarChart;
